//import { useMemo } from 'react';

//import { useInfiniteQuery } from '@tanstack/react-query';

import { FEATURES } from '/src/features/_global/constants';
import { Section } from '../Section';
import { TrendMetric, TrendMetricSection } from '../TrendMetric';
import { TableHeader, TableRow, TableSkeleton } from '../TableSection';
import { DashboardPaywall } from '/src/features/_global/paywalls/DashboardPaywall';
import { usePermissions /*useSelectedSource*/ } from '/src/hooks';
//import { addonListQuery } from '/src/features/addons/queries';
//mport { ADDON_TYPES } from '/src/features/addons/constants';
import { NoSurveysWall } from '/src/features/addons/paywalls/NoSurveysWall';

import { ReactComponent as SurveyIcon } from '@crazyegginc/hatch/dist/images/icon-survey-filled.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function SurveysSection({ data, loading }) {
  return (
    <Section className="col-span-1">
      <Section.Header
        icon={SurveyIcon}
        color="text-wedgewood-500"
        to={{ pathname: '/addons', search: `type=${FEATURES.SURVEYS}` }}
      >
        <span>Survey Activity</span>
      </Section.Header>
      <Section.Body>
        <Content data={data} loading={loading} />
      </Section.Body>
    </Section>
  );
}

function Content({ data, loading }) {
  const permissions = usePermissions();
  const { allowed: canViewDashboard, reason } = permissions.can('view', FEATURES.SURVEYS);

  if (!canViewDashboard) {
    return (
      <div className="p-5">
        <DashboardPaywall feature={FEATURES.SURVEYS} reason={reason} mini={true} />
      </div>
    );
  }

  return <SurveyContent data={data} loading={loading} />;
}

function SurveyContent({ data, loading }) {
  //const { selectedSource } = useSelectedSource();

  /*const { data: addonsData, isLoading } = useInfiniteQuery({
    ...addonListQuery({
      siteId: selectedSource?.id,
      filter: {
        limit: 1,
        query: undefined,
        type: ADDON_TYPES.SURVEY,
      },
    }),
    enabled: Boolean(selectedSource?.id),
  });*/

  /*const surveys = useMemo(
    () => addonsData?.pages.reduce((acc, page) => [...acc, ...(page.addonList?.list ?? [])], []) ?? [],
    [addonsData],
  );*/

  if (!loading && data?.addons.activeSurveys === 0) {
    return (
      <div className="p-5">
        <NoSurveysWall mini={true} />
      </div>
    );
  }

  return (
    <>
      <TrendMetricSection>
        <TrendMetric text="Active" value={data?.addons.activeSurveys} loading={loading} />
        <TrendMetric
          text="Responses"
          value={data?.addons.totalResponses.current}
          oldValue={data?.addons.totalResponses.previous}
          loading={loading}
        />
      </TrendMetricSection>

      {!loading && data?.addons.topSurveys.length === 0 ? null : (
        <div>
          <TableHeader>
            <div>Top 3 surveys</div>
            <div>Responses</div>
          </TableHeader>
          {loading ? (
            <TableSkeleton />
          ) : (
            <>
              {data?.addons.topSurveys.map((s, i) => (
                <TableRow key={s.id} index={i + 1}>
                  <div className="grow truncate">
                    <AppLink className="text-link" to={`/addons/${s.id}`}>
                      {s.name}
                    </AppLink>
                  </div>
                  <div className="ml-4 flex w-12 shrink-0 items-center justify-end text-right">
                    {s.responses.toLocaleString()}
                  </div>
                </TableRow>
              ))}
            </>
          )}
        </div>
      )}
      <Section.SeeMore to={{ pathname: '/addons', search: `type=${FEATURES.SURVEYS}` }} />
    </>
  );
}
